import React, { Component } from "react";
import Item from "../../../../shared/item/Item";
import CheckBox from "../../../../shared/checkBox/CheckBox";
import styles from "../pricingList/PricingList.module.scss";
import { TextValidator } from "react-material-ui-form-validator";
import { withTranslation } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";
import HasPermissionTo from "../../../../common/HasPermissionTo";
import { Table, TableHead, Tooltip } from "@material-ui/core";
import CheckCurrencyValue from "../../../../utils/CheckCurrencyValue";
import OfferDetails from "./offerDetails/OfferDetails";
import Info from "@material-ui/icons/Info";
import PositiveValue from "../../../../utils/PostiveValue";
import {
  CheckBoxTableCell,
  NonEditTableCell,
  SpecsTableCellPricingDetails,
  WarningTableCell,
} from "../../../../shared/pricing/dealerFees/TableComponents";
import { NOTNULL_OR_NOTUNDEFINED } from "../../../../utils/EmpUtil";
import {
  ReactComponent as KeyboardArrowDown,
  ReactComponent as KeyboardArrowUp,
} from "../../../../imgs/chevron-down-blue.svg";
import { CHARGE, DISCOUNT, NONE } from "../../../../common/Constants";
import DealerDiscountTooltip from "./dealerDiscountTooltip/DealerDiscountTooltip";

const StyledInfo = withStyles({
  root: {
    fill: "#4a90e2",
    width: 13,
    marginLeft: 3,
    position: "relative",
    bottom: 7,
  },
})(Info);

const StyledTooltip = withStyles({
  popper: {
    opacity: 1,
    pointerEvents: "auto",
  },
  tooltip: {
    background: "white",
    boxShadow: "1px 1px 9px 0 rgba(0, 0, 0, 0.27)",
    paddingTop: 28,
    paddingLeft: 28,
    paddingRight: 28,
    paddingBottom: 18,
    maxWidth: 375,
  },
})(Tooltip);

class PricingRow extends Component {
  constructor(props) {
    super(props);

    this.buttonRef = React.createRef();
    this.state = {
      tooltipOpen: false,
      valueDropDown: this.getAdjType(this.props.dataRow.adj),
      openEditBox: false,
      dropDownExpanded: false,
    };

    this.handleClickOutsideDropDownButton =
      this.handleClickOutsideDropDownButton.bind(this);
  }

  componentDidMount() {
    document.addEventListener(
      "click",
      this.handleClickOutsideDropDownButton,
      true
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.individualEditIndex !== this.props.individualEditIndex) {
      if (this.props.individualEditIndex === -1) {
        this.setState({
          openEditBox: false,
          valueDropDown: this.getAdjType(this.props.dataRow.adj),
        });
      }
    }

    if (prevProps.isEditEnabled !== this.props.isEditEnabled) {
      this.setState({
        valueDropDown: this.getAdjType(this.props.dataRow.adj),
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener(
      "click",
      this.handleClickOutsideDropDownButton,
      true
    );
  }

  handleClickOutsideDropDownButton(event) {
    if (
      this.buttonRef.current &&
      !this.buttonRef.current.contains(event.target)
    ) {
      this.setState({ dropDownExpanded: false });
    }
  }

  handleChange(value) {
    this.setState({
      valueDropDown: value,
    });
    this.props.updateAdjustment(value);
    this.setState({ dropDownExpanded: false });
  }

  getAdjType = (adj) => {
    let valueDropDown = NONE;
    if (Math.sign(adj) === 1) {
      valueDropDown = CHARGE;
    } else if (Math.sign(adj) === -1) {
      valueDropDown = DISCOUNT;
    }
    return valueDropDown;
  };

  openTooltip = () => this.setState({ tooltipOpen: true });

  closeTooltip = () => this.setState({ tooltipOpen: false });

  toggleEditBox = () => {
    this.setState({ openEditBox: true });
    this.props.updateIndividualEditFlag(true);
  };

  render() {
    const { dataRow } = this.props;
    const rrp = dataRow.rrp;
    const customerSaving = dataRow.totalCustomerSaving;
    const futureIncentives = dataRow.futureIncentives;
    const governmentGrant = (dataRow.vm && dataRow.vm.governmentGrant) || 0;
    const incentives = dataRow.vm && dataRow.vm.incentives;
    const dealerDiscount = PositiveValue(dataRow.adj);

    function rowCheck(editedListed) {
      let checkedMark = false;
      for (const value of editedListed) {
        if (value === dataRow.specs) {
          checkedMark = true;
        }
      }
      return checkedMark;
    }

    const priceAmountPreview =
      dataRow.adjType === NONE || dealerDiscount === 0
        ? this.props.currencySymbol + dealerDiscount
        : dataRow.adjType === DISCOUNT
        ? "-" + this.props.currencySymbol + dealerDiscount
        : "+" + this.props.currencySymbol + dealerDiscount;
    const dealerVehiclePrice = dataRow.dealerVehiclePrice;
    const transactionPrice = NOTNULL_OR_NOTUNDEFINED(dataRow.transactionPrice)
      ? Number.parseFloat(dataRow.transactionPrice).toFixed(2)
      : 0;

    return (
      <div
        id={"pricingRow" + this.props.index}
        data-testid={"pricingRow" + this.props.index}
        className={`${
          (dataRow.priceChanged || !dataRow.released) &&
          !this.props.viewOnlyPricing
            ? styles.rowBorderHighlightPriceChange
            : styles.rowBorderHighlight
        } ${
          dataRow.released &&
          this.props.editChecked &&
          rowCheck(this.props.rowEditedCheckbox)
            ? styles.rowBorderHighlightPriceEdited
            : styles.rowBorderHighlight
        }`}
      >
        <Table>
          <TableHead>
            <WarningTableCell>
              {!this.props.viewOnlyPricing &&
              (dataRow.priceChanged || !dataRow.released) ? (
                <div
                  className={styles.warning}
                  data-testid={"warning" + this.props.index}
                />
              ) : (
                <div>
                  {this.props.newlyReleased ? (
                    <div
                      className={styles.success}
                      data-testid={"success" + this.props.index}
                    />
                  ) : this.props.rowEditSaved &&
                    rowCheck(this.props.rowEditedCheckbox) ? (
                    <div
                      className={styles.success}
                      data-testid={"success" + this.props.index}
                    />
                  ) : (
                    ""
                  )}
                </div>
              )}
            </WarningTableCell>
            <CheckBoxTableCell>
              <CheckBox
                checked={
                  (!dataRow.released && !this.props.viewOnlyPricing) ||
                  (this.props.editChecked &&
                    rowCheck(this.props.rowEditedCheckbox))
                }
                isDisabled={this.props.isDisabled}
              />
            </CheckBoxTableCell>
            <SpecsTableCellPricingDetails>
              <Item value={dataRow.specs} />
            </SpecsTableCellPricingDetails>
            <NonEditTableCell
              className={`${styles.rowItemBold} ${styles.center}`}
            >
              <Item
                data-testid={"year" + this.props.index}
                className={styles.itemWidth}
                value={dataRow.year}
              />
            </NonEditTableCell>
            <NonEditTableCell
              className={`${styles.rowItemBold} ${styles.center}`}
            >
              <Item
                data-testid={"rrp" + this.props.index}
                className={styles.itemWidth}
                value={CheckCurrencyValue(this.props.currencySymbol, rrp, true)}
              />
            </NonEditTableCell>
            <NonEditTableCell className={styles.shadedRowItem}>
              <Item
                value={CheckCurrencyValue(
                  this.props.currencySymbol,
                  customerSaving,
                  true
                )}
              />
              {customerSaving !== 0 && (
                <StyledTooltip
                  open={this.state.tooltipOpen}
                  placement="bottom-start"
                  title={
                    <OfferDetails
                      currencySymbol={this.props.currencySymbol}
                      governmentGrant={governmentGrant}
                      incentives={incentives}
                      futureIncentives={futureIncentives}
                      totalBenefitAmount={customerSaving}
                      closeTooltip={this.closeTooltip}
                      index={this.props.index}
                    />
                  }
                >
                  <StyledInfo
                    onClick={this.openTooltip}
                    data-testid={`tooltipIcon_${this.props.index}`}
                    fontSize="small"
                  />
                </StyledTooltip>
              )}
            </NonEditTableCell>

            <HasPermissionTo
              perform={["dealerAdjustment"]}
              permissions={this.props.user.permissions.rolePermissions}
              render={() => {
                return (
                  <NonEditTableCell>
                    {this.props.isEditEnabled ||
                    (this.state.openEditBox &&
                      this.props.individualEditIndex === this.props.index) ? (
                      <div className={styles.adjDropdown} ref={this.buttonRef}>
                        {/*<FormControl id="menu" className={styles.dropdownItem}>*/}
                        <button
                          className={styles.dropdownButton}
                          type="button"
                          onClick={() =>
                            this.setState({
                              dropDownExpanded: !this.state.dropDownExpanded,
                            })
                          }
                        >
                          <span>
                            {this.state.valueDropDown === NONE ? (
                              <span className={styles.blankDash}></span>
                            ) : this.state.valueDropDown === CHARGE ? (
                              "+" +
                              CheckCurrencyValue(
                                this.props.currencySymbol,
                                0
                              ).slice(0, -1)
                            ) : this.state.valueDropDown === DISCOUNT ? (
                              "-" +
                              CheckCurrencyValue(
                                this.props.currencySymbol,
                                0
                              ).slice(0, -1)
                            ) : (
                              ""
                            )}
                          </span>

                          {!this.state.dropDownExpanded ? (
                            <KeyboardArrowDown
                              className={styles.dropDownArrow}
                            ></KeyboardArrowDown>
                          ) : (
                            <KeyboardArrowUp
                              className={styles.dropDownArrowUp}
                            ></KeyboardArrowUp>
                          )}
                        </button>

                        {this.state.dropDownExpanded && (
                          <div className={styles.dealerAdjustmentDropdown}>
                            <ul className={styles.vehiclesUl}>
                              <li
                                value="0"
                                onClick={() => {
                                  this.handleChange(NONE);
                                  this.props.updateDiscountPrice(0);
                                }}
                              >
                                <p>{this.props.t("CurrentPricing.none")}</p>
                              </li>
                              <li
                                value="1"
                                onClick={() => {
                                  this.handleChange(CHARGE);
                                }}
                              >
                                <p>{this.props.t("CurrentPricing.charge")}</p>
                              </li>
                              <li
                                value="2"
                                onClick={() => {
                                  this.handleChange(DISCOUNT);
                                }}
                              >
                                <p>{this.props.t("CurrentPricing.discount")}</p>
                              </li>
                            </ul>
                          </div>
                        )}

                        {/*</FormControl>*/}
                        <div className={styles.textBox}>
                          <TextValidator
                            value={
                              this.state.valueDropDown === NONE
                                ? 0
                                : dealerDiscount
                            }
                            data-testid={"editDiscount" + this.props.index}
                            validators={[
                              "required",
                              "isNumericWithBigDecimal",
                              "maxNumber:" + `${rrp - customerSaving}`,
                              "minNumber:" + `${-(rrp - customerSaving)}`,
                            ]}
                            errorMessages={[
                              this.props.t("PricingRow.required"),
                              this.props.t("PricingRow.invalidFormat"),
                              this.props.t("PricingRow.errorMaximum"),
                              this.props.t("PricingRow.errorMinimum"),
                            ]}
                            onChange={(e) =>
                              this.props.updateDiscountPrice(e.target.value)
                            }
                            disabled={this.state.valueDropDown === NONE}
                          />
                        </div>
                      </div>
                    ) : (
                      <>
                        <Item
                          className={
                            dataRow.adjType === NONE || dealerDiscount === 0
                              ? styles.normal
                              : dataRow.adjType === DISCOUNT
                              ? styles.discount
                              : styles.charge
                          }
                          datatestid={"itemDiscount" + this.props.index}
                          id={"itemDiscount" + this.props.index}
                          value={priceAmountPreview}
                        />
                        {
                          <StyledTooltip
                            open={
                              this.props.individualEditIndex >= 0 &&
                              this.props.individualEditIndex ===
                                this.props.index
                            }
                            placement="bottom-start"
                            title={
                              <DealerDiscountTooltip
                                toggleEditBox={this.toggleEditBox}
                                updateIndividualEditIndex={
                                  this.props.updateIndividualEditIndex
                                }
                                adjustment={dataRow.adj}
                                recommendedAdjustment={dataRow.recommendedAdj}
                                dataRow={dataRow}
                                resetVehiclesRow={this.props.resetVehiclesRow}
                                index={this.props.index}
                                {...this.props}
                              />
                            }
                          >
                            <span
                              className={
                                dataRow.rrp > dataRow.dealerVehiclePrice ||
                                dataRow.rrp < dataRow.dealerVehiclePrice
                                  ? styles.reset
                                  : ""
                              }
                              data-testid={"reset" + this.props.index}
                              onClick={() => {
                                this.props.updateIndividualEditIndex(
                                  this.props.index
                                );
                                /*this.props.resetVehiclesRow(
                                        e,
                                        dataRow,
                                        this.props.index
                                      );*/
                              }}
                            >
                              {this.props.t("")}
                            </span>
                          </StyledTooltip>
                        }
                      </>
                    )}
                  </NonEditTableCell>
                );
              }}
            />
            <NonEditTableCell
              className={!this.props.isEditEnabled && styles.paddingRight}
            >
              <Item
                datatestid={"itemDealerVehiclePrice" + this.props.index}
                value={CheckCurrencyValue(
                  this.props.currencySymbol,
                  dealerVehiclePrice
                )}
              />
            </NonEditTableCell>
            <NonEditTableCell>
              <Item
                className={styles.itemWidth}
                datatestid={"itemDealerTransactionPrice" + this.props.index}
                value={CheckCurrencyValue(
                  this.props.currencySymbol,
                  transactionPrice
                )}
              />
            </NonEditTableCell>
          </TableHead>
        </Table>
      </div>
    );
  }
}

export default withTranslation("emp")(PricingRow);
